import { render, staticRenderFns } from "./FullBag.vue?vue&type=template&id=0c1f7d4f"
import script from "./FullBag.vue?vue&type=script&lang=js"
export * from "./FullBag.vue?vue&type=script&lang=js"
import style0 from "./FullBag.vue?vue&type=style&index=0&id=0c1f7d4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports